import data from './nimLang_pt.json';
const LocaleConfig = {
    ...data,
    "AllRight": "[Ok]",
    "Ambulance": "[Ambulância]",
    "Angle": "[Anjo]",
    "Angry": " [zangado]",
    "Applause": "[Aplausos]",
    "Awkward": " [Inconfortável]",
    "Beckoning": " [Coração]",
    "Bomb": "[Bomba]",
    "Broken": " [Coração partido]",
    "Bye": "[Adeus]",
    "Cloud": " [Nuvens]",
    "Cool": " [legal]",
    "Cry": " [chorando]",
    "Cute": " [Adorável]",
    "Despise": "[Contemplação]",
    "Disdain": " [Despreza]",
    "Ecstasy": "[Ecstasy]",
    "First": " [Primeiro]",
    "Fist": " [Punho]",
    "Fretting": " [irritação]",
    "Frown": "[franze a testa]",
    "Funny": "[Risos e Choros]",
    "Ghost": " [O fantasma]",
    "GiveMeFive": " [Mão]",
    "GoodJob": "[incrível]",
    "Grimace": "[Grimace]",
    "Halo": " [Os dois olhos]",
    "Happy": "[Feliz]",
    "Hi": " [Aceno de mãos]",
    "Hit": "[Batendo em você]",
    "Hold": "[Espera aí]",
    "Joy": "[Alegria]",
    "Kiss": " [Olha]",
    "Knife": " [tesoura]",
    "Laugh": "[Risos]",
    "Low": "[Nível baixo]",
    "Mad": "[Raiva]",
    "Mask": "[Máscara]",
    "Mischievous": " [Risos]",
    "Monkey": "[Macaco]",
    "Nice": "como",
    "No": "Não!",
    "NoListen": " [Não ouvir]",
    "NoLook": " [Não olhar]",
    "NoWords": "Não diga.",
    "Ok": "Está bem.",
    "Pig": " [Cabeça de porco]",
    "Please": "Buda Amitabha",
    "Poop": "[cocó]",
    "Rocket": "[Rocket]",
    "Sexy": " [Cor]",
    "Shame": " [tímido]",
    "Sleep": " [Dorme]",
    "Sleeping": " [Dormir]",
    "Snicker": "[Sneak]",
    "Spit": "[Estende a língua]",
    "Squint": " [Olhos]",
    "Surprise": " [surpresa]",
    "Sweat": "[suor]",
    "Tears": " [Lágrimas]",
    "Terrorist": "[Terror]",
    "Think": "[Pensando]",
    "Thrill": "[Medo]",
    "Tired": "[Rising Stars]",
    "Uncomfortable": "[Desconforto]",
    "Unhappy": " [infeliz]",
    "acceptFailedText": "Consentimento do pedido falhou",
    "acceptResultText": "Já concordou",
    "acceptText": "Concordo",
    "acceptedText": "Já concordou",
    "accountNotMatchText": "Não encontramos esta conta",
    "accountPlaceholder": "Por favor, insira o número de conta",
    "accountText": "número da conta",
    "addButtonText": "adicionar",
    "addChatMemberText": "Adicionar membros ao chat",
    "addFailedText": "Adicionar falhou",
    "addFriendFailedText": "Não foi possível adicionar um amigo",
    "addFriendMode": "Adicionar o modo amigo",
    "addFriendSuccessText": "Adicionar amigos com sucesso",
    "addFriendText": "Adicionar amigo",
    "addMessageTop": "Coloquei uma mensagem.",
    "addStickTopText": "Subir mensagem",
    "addSuccessText": "Adicionar com sucesso",
    "addTeamMemberConfirmText": "Selecione os membros do grupo a adicionar",
    "addTeamMemberFailedText": "Não foi possível adicionar um membro",
    "addTeamMemberSuccessText": "Adicionar membro com sucesso",
    "addTeamMemberText": "Adicionar Membros",
    "addTeamMemberVerifyText": "Aguardando a verificação",
    "addressText": "livro de endereços",
    "aiAntiSpamText": "Requisito de AI para hit anti-lixo",
    "aiBlockFailedText": "Não permitir operações de lista negra para pessoas digitais",
    "aiConversationSelectFailed": "Falha na seleção da sessão de IA",
    "aiErrorText": "O servidor está ocupado. Tente novamente mais tarde.",
    "aiFriendNotExists": "Amigos não existem.",
    "aiFunctionDisabled": "A função de mensagens AI não está ativada",
    "aiListTitle": "Os meus números.",
    "aiMemberBanned": "Usuários desativados",
    "aiMemberChatBanned": "Usuários são proibidos",
    "aiMenuText": "Os meus números.",
    "aiMessageHitAntiSpam": "Mensagem hit anti lixo",
    "aiNormalTeamChatBanned": "Membros comuns proibidos",
    "aiParameterError": "Parâmetros errados",
    "aiProxyFailedText": "Solicitação do modelo anormal",
    "aiRateLimit": "Frequência excesiva",
    "aiSearchInputPlaceholder": "Adicione mais informações",
    "aiSearchText": "Pesquisa de Artigos AI",
    "aiSearchingText": "AI em busca de terminologia. ..",
    "aiSendingText": "Grande modelo de solicitação em resposta",
    "aiStopFailedText": "Falha ao parar a saída",
    "aiStreamCancelText": "A solicitação foi cancelada",
    "aiStreamText": "Saída de fluxo humano digital",
    "aiTeamChatBanned": "Membros do grupo são proibidos de falar",
    "aiTeamMemberNotExists": "Os membros do grupo não existem",
    "aiTranslateEmptyText": "Digite o que precisa ser traduzido",
    "aiTranslatePlaceholder": "Traduzido para. ..",
    "aiTranslateText": "Processamento AI",
    "aiTranslatedText": "Utilização",
    "aiTranslatingText": "AI em processamento. ..",
    "aiUserText": "Pessoas digitais",
    "aleadyInTeamText": "Já no grupo",
    "aliasText": "Observações",
    "allReadText": "Tudo lido",
    "allUnReadText": "Todas não lidas",
    "amap": "AMAP",
    "applyFriendFailedText": "Falha ao solicitar a adição de amigos",
    "applyFriendSuccessText": "Solicitar adição de amigos com sucesso",
    "applyFriendText": "Adicionar como amigo",
    "applyTeamSuccessText": "Solicitação bem sucedida",
    "applyTeamText": "Aplicar para juntar-se ao grupo",
    "audioMsgText": "Mensagens de áudio",
    "bdmap": "Mapas Baidu",
    "beAddTeamManagersText": "Nomeado administrador",
    "beMentioned": " [Alguém em mim]",
    "beRejectResultText": "Recusou o pedido de amigo",
    "beRemoveTeamManagersText": "Administrador removido",
    "beRemoveTeamText": "Foram removidos do grupo",
    "blackFailedText": "Negro falhou",
    "blackListDesc": " (Você não receberá mensagens de nenhum contato na lista)",
    "blackListTitle": "lista negra",
    "blackMenuText": "lista negra",
    "blackSuccessText": "Negro com sucesso",
    "blackText": "Amigos do apagão",
    "callBusyText": "Ocupados uns aos outros",
    "callCancelText": "Cancelado",
    "callDurationText": "Duração da chamada",
    "callFailed": "Falha na chamada",
    "callMsgText": "Mensagens da lista",
    "callRejectedText": "REJEITO",
    "callTimeoutText": "Tempo ultrapassado",
    "cancelText": "cancelar",
    "cancelUploadFailedText": "Falha ao cancelar o envio",
    "chatButtonText": "Vá conversar.",
    "chatHistoryText": "Registro de conversas",
    "closeAgreeModeText": "Fechar o convite de agrupamento requer consentimento",
    "closeApplyModeText": "Fecha a auditoria de agrupamento",
    "closeText": "fechar",
    "collection": "recolher",
    "collectionFailed": "A coleção falhou",
    "collectionSuccess": "Colecionado",
    "collectionText": "recolher",
    "commentText": "deixar uma mensagem",
    "confirmDeleteFriendText": "Tem certeza de excluir amigos?",
    "confirmDeleteText": "Tem certeza de apagar?",
    "confirmRemoveCollection": "Confirmar a exclusão da coleção?",
    "createButtonText": "criar",
    "createDiscussionText": "Criar um grupo de discussão",
    "createTeamFailedText": "Falha na criação do grupo",
    "createTeamMemberLimitText": "Número máximo de pessoas",
    "createTeamSuccessText": "Criação de grupo com sucesso",
    "createTeamText": "Criar Grupo",
    "customMsgText": "Mensagem personalizada",
    "deleteFriendFailedText": "Falha ao apagar o amigo",
    "deleteFriendSuccessText": "Excluir amigos com sucesso",
    "deleteFriendText": "Excluir um amigo",
    "deleteSessionText": "Excluir sessão",
    "deleteStickTopText": "Cancelar o topo",
    "deleteText": "apagar",
    "discussionAvatarText": "Avatar do grupo de discussão",
    "discussionDoNotDisturbText": "Grupo de discussão sem perturbações",
    "discussionIdText": "ID do grupo de discussão",
    "discussionMemberText": "Membros do Grupo de Discussão",
    "discussionText": "Informações do grupo de discussão",
    "discussionTitle": "Nome do grupo de discussão",
    "dismissTeamConfirmText": "Confirmar a dissolução do grupo",
    "dismissTeamFailedText": "Falha na dissolução do grupo",
    "dismissTeamSuccessText": "O grupo foi dissolvido com sucesso",
    "dismissTeamText": "Dissolver o grupo",
    "editNickInTeamText": "Editar o meu apelido no grupo",
    "emailErrorText": "Formato de caixa de correio incorreto",
    "emailPlaceholder": "Por favor, insira o e-mail",
    "emailText": "Caixa de correio",
    "enText": "English",
    "enableV2CloudConversationText": "Se abrir uma sessão na nuvem",
    "enterTeamText": "Entrou no grupo",
    "expiredResultText": "Expirou",
    "fileMsgText": "Mensagem do ficheiro",
    "forwardFailedText": "Falha no encaminhamento",
    "forwardSuccessText": "Enviar com sucesso",
    "forwardText": "Enviar",
    "friendListTitle": "Meu amigo",
    "friendMenuText": "Meu amigo",
    "friendText": "Amigo",
    "genderPlaceholder": "Escolha o sexo",
    "genderText": "Sexo",
    "geoMsgShortText": "Localização",
    "geoMsgText": "Mensagens de localização geográfica",
    "getApplyMsgFailedText": "Falha ao obter a mensagem",
    "getCollectionFailed": "Falha na consulta da lista de favoritas",
    "getHistoryMsgFailedText": "Falha ao obter a mensagem do histórico",
    "getRelationFailedText": "Falha na obtenção da relação",
    "huff": "[Zangado]",
    "ill": " [desconfortável]",
    "imgMsgText": "Imagem Mensagem",
    "imgText": "imagem",
    "inCallText": "Já está em chamada. Por favor, encerra a chamada e ligue novamente.",
    "inviteTeamText": "Convide-o a participar",
    "inviteText": "convidar",
    "joinTeamFailedText": "Falha ao juntar-se ao grupo",
    "joinTeamSuccessText": "Junte-se ao grupo com sucesso",
    "joinTeamText": "Juntar-se a um grupo",
    "joinTeamWithVerifyText": "O pedido de inscrição foi enviado",
    "languageText": "língua",
    "leaveDiscussionButtonText": "Sair do grupo de discussão",
    "leaveDiscussionConfirmText": "Confirmar a saída do grupo de discussão",
    "leaveDiscussionFailedText": "Falha ao sair deste grupo",
    "leaveDiscussionSuccessText": "Saiu com sucesso deste grupo",
    "leaveDiscussionText": "Saiu do grupo de discussão",
    "leaveDiscussionTitle": "Sair do grupo de discussão",
    "leaveTeamButtonText": "Apagar e sair",
    "leaveTeamConfirmText": "Confirmar a saída do grupo",
    "leaveTeamFailedText": "Falha ao sair deste grupo",
    "leaveTeamSuccessText": "Saiu com sucesso deste grupo",
    "leaveTeamText": "Saiu do grupo.",
    "leaveTeamTitle": "Sair do grupo",
    "logoutConfirmText": "Tem certeza de sair do login?",
    "logoutText": "Sair do login",
    "man": "masculino",
    "maxSelectedText": "Só escolher, no máximo.",
    "memberNotExistsText": "Usuário não existe",
    "msgListTitle": "Centro de mensagens",
    "msgMenuText": "Centro de mensagens",
    "msgRecallTimeErrorText": "Não é possível retirar após o tempo",
    "muteAllTeamFailedText": "Falha ao ativar a proibição de todos",
    "muteAllTeamSuccessText": "Iniciar todas as proibições com sucesso",
    "muteSessionText": "Ativar sem perturbação",
    "needBeInvitedText": "É necessário o consentimento do convidado.",
    "needMentionText": "Se você precisa de mensagens@",
    "needVerifyText": "Verificação necessária",
    "networkDisconnectText": "A conexão de rede foi desconectada, verifique as configurações de rede e tente se conectar novamente",
    "newGroupOwnerText": "Torne-se um novo mestre",
    "nickInTeamText": "O meu apelido no grupo.",
    "nickPlaceholder": "Por favor, insira o apelido",
    "nickText": "Apelido",
    "noMoreCollectionText": "Deslizaram para o fundo",
    "noMoreText": "Não há mais notícias.",
    "noPermission": "Você não tem permissão para operar",
    "noText": "Não",
    "notAnAi": "Não é uma conta digital.",
    "notNeedBeInvitedText": "Não é necessário o consentimento do convidado.",
    "notNeedVerifyText": "Não é necessária verificação",
    "notSupportJoinText": "O grupo de discussão não pode ser integrado diretamente, por favor entre em contato com o administrador",
    "notSupportMessageText": "Esta mensagem ainda não é suportada",
    "notiMsgText": "Mensagem de notificação",
    "offlineText": "(Offline)",
    "ok": "[OK]",
    "okText": "certo",
    "onDismissDiscussionText": "O grupo de discussão foi dissolvido.",
    "onDismissTeamText": "O grupo foi dissolvido.",
    "onRemoveTeamText": "Você foi retirado do grupo",
    "onlineText": " (em linha)",
    "onlyTeamOwner": "Somente os senhores",
    "openAgreeModeText": "O convite de agrupamento é aberto e requer consentimento",
    "openApplyModeText": "A auditoria de agrupamento foi iniciada",
    "openText": "abrir",
    "oppositeSide": "um ao outro",
    "p2pMsgVisibleModeText": "Mostrar ou não mensagens P2P lidas",
    "passFriendAskText": "Eu concordei com sua candidatura, comece a conversar agora.",
    "passResultText": "Aplicação de amigo aprovada",
    "personUnit": "Pessoas",
    "phonePlaceholder": "Digite o número de telefone",
    "phoneText": "telemóvel",
    "pinAIText": "PIN para cima",
    "processedValidationMessageText": "Esta mensagem de autenticação foi processada",
    "readText": "Leio",
    "recallMessageText": "Retirou uma mensagem.",
    "recallReplyMessageText": "A mensagem foi retirada ou apagada",
    "recallText": "retirar",
    "receiveText": "Recebeu uma nova mensagem",
    "recentConversationText": "Sessões recentes",
    "recentForwardText": "Redirecionado recentemente",
    "recentSessionText": "Visitado recentemente",
    "reeditText": "Reeditar",
    "regenAIMsgFailedText": "Falha na regeneração",
    "rejectFailedText": "A recusa do pedido falhou",
    "rejectResultText": "REJEITO",
    "rejectTeamFailedText": "Falha na recusa da solicitação de grupo",
    "rejectTeamInviteText": "Rejeitou convite em grupo",
    "rejectText": "Recusar",
    "rejectedTeamText": "Aplicação de grupo recusada",
    "rejectedText": "O pedido foi recusado",
    "removeBlackFailedText": "Falha no desbloqueio",
    "removeBlackSuccessText": "Desmantelamento de Negro com Sucesso",
    "removeBlackText": "Libertar o Blackout",
    "removeCollectionFailed": "Não foi possível apagar a coleção",
    "removeCollectionSuccess": "Excluir a coleção com sucesso",
    "removeMessageTop": "Removendo a mensagem de topo",
    "removeTeamMemberConfirmText": "Confirmou a remoção do membro?",
    "removeTeamMemberFailedText": "Falha na remoção do membro",
    "removeTeamMemberSuccessText": "Remoção de membros com sucesso",
    "removeTeamMemberText": "Remover Membros",
    "replyText": "Resposta",
    "robotMsgText": "Mensagens da máquina",
    "saveFailedText": "Falha na gravação",
    "saveSuccessText": "Salvar com sucesso",
    "saveText": "salvar",
    "sdkVersionSelectionText": "Escolha a versão do SDK",
    "searchButtonText": "encontrar",
    "searchDiscussionMemberPlaceholder": "Pesquisar membros do grupo de discussão",
    "searchDiscussionTitle": "Grupo de Discussão",
    "searchEmptyText": "Ainda não adicionou amigos ou grupos",
    "searchFriendTitle": "Amigo",
    "searchInputPlaceholder": "procurar",
    "searchNoResText": "Nenhum resultado",
    "searchTeamMemberPlaceholder": "Pesquisar membros do grupo",
    "searchTeamPlaceholder": "Digite o nome do grupo",
    "searchTeamTitle": "grupo",
    "searchText": "procurar",
    "searchTipText": "Enter Pesquisar",
    "securityTipText": "Apenas para experimentar a funcionalidade do produto de mensagens instantâneas da Cloud. Não confie em informações relacionadas a transferências de dinheiro, ganhos, etc. e não faça chamadas desconhecidas facilmente.",
    "selectedText": "seleccionado",
    "sendBlackFailedText": "Você foi puxado para a lista negra.",
    "sendBtnText": "envio",
    "sendEmptyText": "Não é possível enviar uma mensagem em branco",
    "sendMsgFailedText": "Falha no envio da mensagem",
    "sendNotFriendFailedText": "Relações não amigas atuais",
    "sendText": "enviar uma mensagem",
    "sendToText": "Enviar Para",
    "sendUsageText": "(Pressione enter para enviar diretamente, shift + enter para embrulhar)",
    "session": "conversa",
    "setText": "Configurações",
    "settingText": "Configurações",
    "signPlaceholder": "Por favor, insira a assinatura",
    "signText": "assinatura",
    "strangerNotiText": "Atualmente não é seu amigo, por favor, tome nota para proteger a privacidade pessoal.",
    "strangerText": "Um estranho.",
    "teamAgreeModeExplainText": "Quando habilitado, os membros precisam do consentimento do proprietário ou do administrador para se juntarem ao grupo",
    "teamAgreeModeText": "Auditoria de grupo",
    "teamAll": "Todos.",
    "teamAtModeText": "Quem pode @ todos",
    "teamAvatarConfirmText": "A cabeça não pode estar vazia.",
    "teamAvatarText": "Imagem de grupo",
    "teamDoNotDisturbText": "Grupos sem perturbação",
    "teamIdNotMatchText": "Não encontra este número de grupo",
    "teamIdPlaceholder": "Digite o ID do grupo",
    "teamIdText": "ID do grupo",
    "teamInfoText": "Dados do Grupo",
    "teamInviteModeText": "Quem pode convidar novos membros?",
    "teamJoinModeExplainText": "Após a abertura, puxe para o grupo, requer consentimento do convidado",
    "teamJoinModeFreeText": "Inscreva-se livremente sem verificação",
    "teamJoinModeNeedVerifyText": "Requer inscrição após o consentimento do proprietário ou administrador do grupo",
    "teamJoinModeText": "Convite ao grupo requer consentimento",
    "teamListTitle": "Os Meus Grupos",
    "teamManagerEditText": "Gestão de Pessoal",
    "teamManagerEmptyText": "Não há gerentes",
    "teamManagerEnableText": "Habilitar o gerenciador de grupos",
    "teamManagerLimitText": "Quem pode alterar os dados",
    "teamManagerText": "Gestor de grupo",
    "teamMemberLimitText": "Número máximo de membros atingido",
    "teamMemberNotExist": "Essa conversa de grupo já não existe.",
    "teamMemberText": "Membros do Grupo",
    "teamMenuText": "Os Meus Grupos",
    "teamMsgVisibleModeText": "Mostrar se as mensagens de grupo são lidas sem ler",
    "teamMutePlaceholder": "Banho atual de conversa em grupo",
    "teamMuteText": "Proibição de grupo",
    "teamNotExitsText": "O grupo não existe",
    "teamOwnerAndManagerText": "Proprietários e administradores",
    "teamOwnerText": "Mestres",
    "teamPowerText": "Gestão de grupos",
    "teamSignPlaceholder": "Por favor, digite o conteúdo",
    "teamSignText": "Apresentação do Grupo",
    "teamTitle": "Nome do grupo",
    "teamTitleConfirmText": "O nome do grupo não pode estar vazio",
    "teamTitlePlaceholder": "Digite o nome do grupo",
    "teamTopModeText": "Quem pode dar a notícia?",
    "textMsgText": "Mensagem de texto",
    "tipAIFailedMessageText": "Falha ao solicitar o modelo de linguagem grande",
    "tipAIMessageText": "Formato não suportado",
    "tipMsgText": "Mensagem de sugestão",
    "topFailedText": "O topo falhou",
    "topText": "Topo",
    "transferOwnerConfirmText": "Confirmar o proprietário da transferência",
    "transferOwnerText": "Transferência de proprietários",
    "transferTeamFailedText": "Falha na transferência de proprietários",
    "transferTeamSuccessText": "Transferência de proprietários com sucesso",
    "transferToText": "Transferir para",
    "txmap": "Mapas Tencent",
    "unTopText": "Cancelar o topo",
    "unknow": "Desconhecido",
    "unknowMsgText": "Mensagem desconhecida",
    "unmuteAllTeamFailedText": "Fim da proibição de todos falhou",
    "unmuteAllTeamSuccessText": "Fim da proibição de todos com sucesso",
    "unmuteSessionText": "Cancelar sem perturbação",
    "unreadText": "Não lido",
    "updateAliasFailedText": "Falha na modificação do comentário",
    "updateAliasSuccessText": "Modificação da nota com sucesso",
    "updateAllowAt": "Atualizado \"@ todos os direitos humanos\" para",
    "updateAllowTop": "Atualizar permissões de mensagem para",
    "updateBitConfigMaskFailed": "Falha na atualização da mensagem de grupo sem interrupção",
    "updateBitConfigMaskSuccess": "Atualização de mensagens de grupo sem interrupção com sucesso",
    "updateMyMemberNickFailed": "Não foi possível atualizar o meu apelido de grupo",
    "updateMyMemberNickSuccess": "Atualizar o meu apelido de grupo com sucesso",
    "updateTeamAvatar": "Atualizado cabeçalho de grupo",
    "updateTeamFailedText": "Falha na modificação",
    "updateTeamIntro": "Atualização da apresentação do grupo",
    "updateTeamInviteMode": "Atualizado a permissão de grupo \"Convidar outros direitos\" para",
    "updateTeamManagerFailText": "Falha na modificação do administrador de grupo",
    "updateTeamManagerSuccessText": "Modificação do administrador de grupo com sucesso",
    "updateTeamMute": "Atualizado \"Proibição de grupo\" para",
    "updateTeamName": "Atualizar o nome do grupo para",
    "updateTeamSuccessText": "Modificação bem sucedida",
    "updateTeamUpdateTeamMode": "Atualizada a permissão de grupo \"Permissão de modificação de dados de grupo\" para",
    "uploadImgFailedText": "Falha no envio da imagem",
    "uploadLimitText": "Suporte máximo para imagens, vídeos ou tamanhos de arquivos",
    "uploadLimitUnit": "M",
    "userNotInTeam": "Os membros já não estão no grupo.",
    "vedioCallText": "Chamadas de vídeo",
    "verifyMsgNotExitsText": "Esta mensagem de autenticação foi processada",
    "videoMsgText": "Mensagens de vídeo",
    "videoText": "Vídeo",
    "voiceCallText": "Chamadas de voz",
    "voiceToText": "Voz para texto",
    "voiceToTextFailedText": "Falha na conversão de texto",
    "welcomeText": "Bem-vindo à nuvem",
    "woman": "Mulheres",
    "yesText": "correcto",
    "you": "você",
    "zhText": "Chinês"
}

export default LocaleConfig
